export default {
  baseLayoutSubtitle: 'Gilt für jeden Bericht, sofern ein Bericht eine Einstellung nicht überschreibt.',
};
